import { render, staticRenderFns } from "./GradeGroups.vue?vue&type=template&id=35d47624&scoped=true&"
import script from "./GradeGroups.vue?vue&type=script&lang=js&"
export * from "./GradeGroups.vue?vue&type=script&lang=js&"
import style0 from "./GradeGroups.vue?vue&type=style&index=0&id=35d47624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d47624",
  null
  
)

export default component.exports